import React from 'react';
import styled from 'react-emotion';

const Button = ({ className, onClick }) => (
  <button className={className} onClick={onClick}>
    <i className='fas fa-times' />
  </button>
);

const StyledButton = styled(Button)`
  position: absolute;
  top: 10px;
  right: 10px;
  border: 0;
  font-size: 20px;
  cursor: pointer;
  color: #ddd;
  &:hover{ color: #999; }
  &:active{outline: none;}
`;

export default StyledButton;
